const formattedNumber = (number) => {
  return number.toLocaleString(
    'pl-PL',
    { style: 'currency', currency: 'pln' }
  );
}

export default formattedNumber;
